// extracted by mini-css-extract-plugin
export var videoHero = "_bs-4";
export var videoHeroImage = "_bs-5";
export var videoHeroOverlay = "_bs-6";
export var videoHeroSubtitle = "_bs-8";
export var videoHeroText = "_bs-7";
export var videoLauncher = "_bs-0";
export var videoLauncherIcon = "_bs-1";
export var videoLauncherSubtitle = "_bs-3";
export var videoLauncherTitle = "_bs-2";
export var videoPlayer = "_bs-a";
export var videoPlayerWrap = "_bs-9";